/** @format */

import {parseISO} from 'date-fns';

interface Options {
  startOn?: string;
  endOn: string;
}

const isIncludeYear = ({startOn, endOn}: Options) => {
  if (!startOn) {
    return false;
  }

  const parsedStart = parseISO(startOn);
  const parsedEnd = parseISO(endOn);
  const yearStart = parsedStart.getFullYear();
  const yearEnd = parsedEnd.getFullYear();

  return yearStart !== yearEnd;
};

export {isIncludeYear};
